// useWaitingInPage.ts
import { useEffect, useRef } from "react";

type LogPayload = {
	category: string;
	path: string;
	action: string;
	event: string;
	value?: string;
};

type Options = {
	enabled?: boolean; // 預設 true
	getPath: () => string;
	logEvent: (payload: LogPayload) => void;
	getValue?: () => string; // 可選，不給就用內部 count
};

const INTERVAL_MS = 5 * 1000; //多久打一次

export function useWaitingInPage({
	enabled = true,
	getPath,
	logEvent,
	getValue,
}: Options) {
	const countRef = useRef(0);
	const timerRef = useRef<number | null>(null);

	useEffect(() => {
		if (!enabled) return;

		const tick = () => {
			logEvent({
				category: "mgm",
				path: getPath(),
				action: "stay",
				event: "mgm_stay",
				value: getValue?.() ?? String(countRef.current),
			});

			timerRef.current = window.setTimeout(tick, INTERVAL_MS);
		};

		tick(); // 進頁立即打一筆（不想立即打就移除）

		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
				timerRef.current = null;
			}
		};
	}, [enabled, getPath, getValue, logEvent]);

	return {
		reset: () => {
			countRef.current = 0;
		},
	};
}
